import { r as a, c as o, h as t, H as n, g as l } from "./main-bb89b2f2.js";
import "vue";
const h = "*,:after,:before{border-color:var(--color-neutral-steel-200);border-style:solid;border-width:0;box-sizing:border-box}a{color:inherit;text-decoration:inherit}audio,canvas,embed,iframe,img,object,svg,video{display:block;vertical-align:middle}button,input,optgroup,select,textarea{font-feature-settings:inherit;color:inherit;font-family:inherit;font-size:100%;font-variation-settings:inherit;font-weight:inherit;letter-spacing:inherit;line-height:inherit;margin:0;padding:0}blockquote,dd,dl,fieldset,figure,h1,h2,h3,h4,h5,h6,hr,p,pre{margin:0}fieldset,legend{padding:0}.relative{position:relative}.block{display:block}.h-fit{height:-moz-fit-content;height:fit-content}:host{display:block}.loadingBarWrapper{box-sizing:border-box;height:-moz-fit-content;height:fit-content;position:relative}@keyframes draw{to{stroke-dashoffset:0}}.static{position:static}.mt-2{margin-top:var(--spacing-2)}.flex{display:flex}.h-full{height:100%}.w-full{width:100%}.w-fit{width:-moz-fit-content;width:fit-content}.flex-col{flex-direction:column}.items-end{align-items:flex-end}.items-center{align-items:center}.justify-between{justify-content:space-between}.gap-x-2{-moz-column-gap:var(--spacing-2);column-gap:var(--spacing-2)}.gap-x-\\[24px\\]{-moz-column-gap:24px;column-gap:24px}.gap-x-\\[6px\\]{-moz-column-gap:6px;column-gap:6px}.font-text{font-family:var(--copytext-font-family)}.text-copy-extra-small-uniform{font-size:var(--copytext-font-size-extra-small-noctx);line-height:var(--copytext-line-height-extra-small-noctx)}.text-copy-smaller-uniform{font-size:var(--copytext-font-size-smaller-noctx);line-height:var(--copytext-line-height-smaller-noctx)}.absolute{position:absolute}.bottom-0{bottom:var(--spacing-0)}.top-\\[-8px\\]{top:-8px}.mr-\\[12px\\]{margin-right:12px}.h-\\[20px\\]{height:20px}.w-\\[45px\\]{width:45px}.resize{resize:both}.justify-start{justify-content:flex-start}.justify-end{justify-content:flex-end}.pt-\\[12px\\]{padding-top:12px}.text-right{text-align:right}.font-text-bold{font-family:var(--copytext-font-family-bold)}.text-copy-small-uniform{font-size:var(--copytext-font-size-small-noctx);line-height:var(--copytext-line-height-small-noctx)}", c = h, d = class {
  constructor(i) {
    a(this, i), this.loadingComplete = o(this, "lhLoadingComplete", 7), this.progressChange = o(this, "lhProgressChange", 7), this.startAnimation = !1, this.endAnimation = !1, this.progressLabelOffset = 0, this.progressLabelSize = 0, this.orientation = "horizontal", this.direction = "right", this.color = "default", this.duration = 1e3, this.name = "", this.progress = 0, this.width = "100%", this.interval = [0, 100], this.showLabel = !0, this.currProgress = 0, this.currContSizeState = 0;
  }
  intervalPropWatcher() {
    if (!Array.isArray(this.interval) || this.interval.length != 2 || this.interval[0] >= this.interval[1])
      throw new Error("Invalid intervall definition");
    (this.progress < this.interval[0] || this.progress > this.interval[1]) && (this.progress = this.interval[0]), this.currProgress = this.progress, this.internalUpdate();
  }
  progressPropWatcher(i) {
    if (this.interval == null || !Array.isArray(this.interval))
      throw new Error("Intervall not defined");
    if (i < this.interval[0]) {
      this.currProgress = this.interval[0], this.internalUpdate();
      return;
    }
    if (i > this.interval[1]) {
      this.currProgress = this.interval[1], this.internalUpdate();
      return;
    }
    this.currProgress = this.progress, this.internalUpdate();
  }
  /**
   * Resize listener to adjust the widths of the component container.
   */
  handleResize() {
    this.internalUpdate();
  }
  /**
   * Public function to start the determinate loading bar
   */
  async start() {
    this.startAnimation === !1 && (this.startAnimation = !0, this.endAnimation = !1, this.progressLabel());
  }
  /**
   * Public function to reset the determinate loading bar
   */
  async reset() {
    if (this.startAnimation) {
      this.startAnimation = !1, this.endAnimation = !0;
      return;
    }
    this.internalReset();
  }
  componentWillLoad() {
    this.intervalPropWatcher(), this.currProgress = this.progress, this.evaluatedColor = this.evaluateColor();
  }
  componentWillUpdate() {
    this.evaluatedColor = this.evaluateColor();
  }
  componentDidLoad() {
    this.internalUpdate();
  }
  progressLabel() {
    let i = this.progress, r = 0;
    const e = this.interval[1] - this.interval[0], s = setInterval(() => {
      if (this.endAnimation === !0) {
        clearInterval(s), this.internalReset();
        return;
      }
      i++, this.currProgress = i, r = this.progressLabelSize / 100 * this.currProgress, this.progressLabelOffset = this.currContSizeState * i / 100 - r, this.progressChange.emit(this.currProgress), i === this.interval[1] && (this.loadingComplete.emit({ response: "Loading completed." }), clearInterval(s), this.startAnimation = !1, this.endAnimation = !0);
    }, this.duration / e);
  }
  internalReset() {
    this.startAnimation = !1, this.endAnimation = !1, this.currProgress = this.progress, this.progressChange.emit(this.currProgress), this.internalUpdate();
  }
  internalUpdate() {
    this.progressLabelSize = this.orientation === "vertical" ? 20 : 42;
    const i = this.progressLabelSize / 100 * this.currProgress, r = this.hostElement.shadowRoot.getElementById("loading-bar-container");
    if (r == null)
      return;
    const s = window.getComputedStyle(r).getPropertyValue(this.orientation === "horizontal" ? "width" : "height");
    this.currContSizeState = parseFloat(s), this.progressLabelOffset = this.currContSizeState * this.currProgress / 100 - i;
  }
  /**
   * Evaluate color and return value
   * @param isLabel Define if value is used to colorize the label
   */
  evaluateColor(i = !1) {
    return this.color === "green" ? "var(--loadingbar-color-success)" : this.color === "orange" ? i ? "var(--loadingbar-color-warning-label)" : "var(--loadingbar-color-warning-track)" : this.color === "red" ? "var(--loadingbar-color-error)" : i || this.color === "blackWhite" ? "var(--loadingbar-text-default)" : "var(--loadingbar-color-default)";
  }
  // eslint-disable-next-line complexity
  render() {
    const i = {
      loadingBarWrapper: !0
    }, r = {
      "font-text-bold text-copy-small-uniform": !0,
      "pt-[12px]": this.direction === "right",
      "pt-[12px] text-right": this.direction === "left",
      "absolute bottom-0": this.direction === "up",
      "flex justify-end": this.currProgress === 100 && this.orientation === "horizontal" && this.direction === "right",
      "flex justify-start": this.currProgress === 100 && this.orientation === "horizontal" && this.direction === "left"
    }, e = this.currContSizeState / 100 * this.currProgress;
    return this.orientation === "horizontal" ? t(n, null, t("div", { class: i, id: "loading-bar-container", style: { width: this.width.includes("%") ? this.width : this.currContSizeState + "px" } }, t("div", { class: "absolute", innerHTML: `
            <svg height="8" width="${this.currContSizeState + "px"}">
              <line
                x1="${this.direction == "left" ? this.currContSizeState : "0"}"
                y1="0"
                x2="${this.direction == "right" ? this.currContSizeState : "0"}"
                y2="0"
                stroke="var(--loadingbar-surface-default)"
                stroke-width="8"
                fill="transparent"
              />
            </svg>
            ` }), t("div", { class: "absolute", innerHTML: `
            <svg height="8" width="${this.currContSizeState + "px"}">
              <line
                x1="${this.direction == "left" ? this.currContSizeState - e : "0"}"
                y1="0"
                x2="${this.direction == "right" ? e : this.currContSizeState}"
                y2="0"
                stroke="${this.evaluatedColor}"
                stroke-width="8"
                fill="transparent"
              />
            </svg>` }), this.startAnimation && t("div", { class: "absolute", innerHTML: `
              <svg height="8" width="${this.currContSizeState + "px"}">
                <line
                  x1="${this.direction == "right" ? e : this.direction == "left" ? this.currContSizeState * this.interval[1] / 100 : 0}"
                  y1="0"
                  x2="${this.direction == "left" ? e : this.direction == "right" ? this.currContSizeState * this.interval[1] / 100 : 0}"
                  y2="0"
                  stroke=${this.evaluatedColor}
                  stroke-width="8"
                  fill="transparent"
                  style="stroke-dasharray: ${this.currContSizeState * this.interval[1] / 100}px; stroke-dashoffset: ${this.currContSizeState * this.interval[1] / 100}px; animation: draw ${this.duration * this.interval[1] / 100}ms linear forwards"
                />
              </svg>` }), this.showLabel && t("div", { class: r }, t("label", { style: {
      marginLeft: `${this.direction == "right" ? this.currProgress === 100 ? "0" : this.progressLabelOffset : "0"}px`,
      marginRight: `${this.direction == "left" ? this.progressLabelOffset : "0"}px`,
      color: `${this.evaluateColor(!0)}`
    } }, t("slot", { name: "label" }, `${this.currProgress}%`))))) : (
      // Vertical
      t(n, null, t("div", { class: i, id: "loading-bar-container", style: { height: this.width.includes("%") ? this.width : this.currContSizeState + "px" } }, t("div", { class: "flex items-center" }, t("div", { class: "flex justify-end mr-[12px] w-[45px] h-[20px]" }, this.showLabel && t("div", { id: "loadingLabelWrapper", class: r, style: {
        marginTop: `${this.direction == "down" ? this.progressLabelOffset : "0"}px`,
        marginBottom: `${this.direction == "up" ? this.progressLabelOffset : "0"}px`,
        color: `${this.evaluateColor(!0)}`
      } }, t("slot", { name: "label" }, t("label", null, `${this.currProgress}%`)))), t("div", { class: "relative top-[-8px]" }, t("div", { class: "absolute", innerHTML: `
                <svg height="${this.currContSizeState + "px"}" width="8">
                  <line
                    x1="0"
                    y1="${this.direction == "down" ? this.currContSizeState : "0"}"
                    x2="0"
                    y2="${this.direction == "up" ? this.currContSizeState : "0"}"
                    stroke="var(--loadingbar-surface-default)"
                    stroke-width="8"
                    fill="transparent"
                  />
                </svg>` }), t("div", { class: "absolute", innerHTML: `
                <svg height="${this.currContSizeState + "px"}" width="8">
                  <line
                    x1="0"
                    y1="${this.direction == "up" ? this.currContSizeState - e : "0"}"
                    x2="0"
                    y2="${this.direction == "down" ? e : this.currContSizeState}"
                    stroke="${this.evaluatedColor}"
                    stroke-width="8"
                    fill="transparent"
                  />
                </svg>` }), this.startAnimation ? t("div", { class: "absolute", innerHTML: `
                  <svg height="${this.currContSizeState + "px"}" width="8">
                    <line
                      x1="0"
                      y1="${this.direction == "down" ? e : this.direction == "up" ? this.currContSizeState * this.interval[1] / 100 : 0}"
                      x2="0"
                      y2="${this.direction == "up" ? e : this.direction == "down" ? this.currContSizeState * this.interval[1] / 100 : 0}"
                      stroke="${this.evaluatedColor}"
                      stroke-width="8"
                      fill="transparent"
                      style="stroke-dasharray: ${this.currContSizeState * this.interval[1] / 100}px; stroke-dashoffset: ${this.currContSizeState * this.interval[1] / 100}px; animation: draw ${this.duration * this.interval[1] / 100}ms linear forwards"
                    />
                  </svg>` }) : null))))
    );
  }
  get hostElement() {
    return l(this);
  }
  static get watchers() {
    return {
      interval: ["intervalPropWatcher"],
      progress: ["progressPropWatcher"]
    };
  }
};
d.style = c;
export {
  d as patternlib_loadingbar
};
